<h2>Contact information</h2>

<ng-container *ngIf="!contactInfoRequired">
    <p>We'll follow up if we need more details.
        <strong>Your personal information will be kept strictly confidential.</strong>
    </p>
</ng-container>

<ng-container *ngIf="contactInfoRequired && canCreateCodeCase">
    <p>We require this information because you're reporting a possible bylaw infraction and we may need to follow up for
        more details.
        <strong>Your personal information will be kept strictly confidential.</strong>
    </p>
</ng-container>

<ng-container *ngIf="contactInfoRequired && !canCreateCodeCase">
    <p>We require this information because you're reporting a problem possibly requiring further contact and we may need
        to follow up for more details.
        <strong>Your personal information will be kept strictly confidential.</strong>
    </p>
</ng-container>

<p><span class="asteriskColoring">*</span> indicates a required field</p>

<form class="formContainer" [formGroup]="contactForm">
    <div class="nameInfo">
        <div class="firstName">
            <label for="firstNameField" [class.required-field]="contactInfoRequired">
                First name

                <!-- <ng-container *ngIf="!contactInfoRequired">
                    <span class="optionalTag">(optional)</span>
                </ng-container> -->
            </label>
            <input formControlName="firstNameControl" type="text" id="firstNameField" [class.preNextErrorInput]="getControlInvalid('firstNameControl')"
                [class.inputError]="firstNameError" name="firstNameField" (focusout)="handleCheckErrors($event)"
                (input)="updateContactInfo($event)" tabindex="1">

            <ng-container *ngIf="firstNameError">
                <span class="formErrorMsg">Please enter in your first name.</span>
            </ng-container>
        </div>

        <div class="lastName">
            <label for="lastNameField" [class.required-field]="contactInfoRequired">
                Last name

                <!-- <ng-container *ngIf="!contactInfoRequired">
                    <span class="optionalTag">(optional)</span>
                </ng-container> -->
            </label>
            <input formControlName="lastNameControl" type="text" id="lastNameField" name="lastNameField"
                [class.inputError]="lastNameError" (input)="updateContactInfo($event)" class="noMarginRight"
                (focusout)="handleCheckErrors($event)" tabindex="1" [class.preNextErrorInput]="getControlInvalid('lastNameControl')">

            <ng-container *ngIf="lastNameError">
                <span class="formErrorMsg">Please enter in your last name.</span>
            </ng-container>
        </div>
    </div>

    <ng-container *ngIf="contactInfoRequired && !nameEmailReqOnly">
        <div class="addressInfo">
            <label for="addressField" [class.required-field]="contactInfoRequired">Address </label>
            <input formControlName="addressControl" type="text" id="addressField" [class.inputError]="addressError"
                name="addressField" (input)="updateContactInfo($event)" class="noMarginRight"
                (focusout)="handleCheckErrors($event)" tabindex="1" [class.preNextErrorInput]="getControlInvalid('addressControl')">

            <ng-container *ngIf="addressError">
                <span class="formErrorMsg">Please provide an address for the problem.</span>
            </ng-container>
        </div>
    </ng-container>

    <div class="phoneInfo">
        <div class="phoneOne">
            <label for="phoneNumberField" [class.required-field]="contactInfoRequired && !nameEmailReqOnly && !nameAddressEmailReqOnly">
                Phone number
                <!-- <ng-container *ngIf="!contactInfoRequired">
                    <span class="optionalTag">(optional)</span>
                </ng-container> -->
            </label>
            <div class="phoneDetails">
                <select formControlName="phoneTypeControl" name="phoneNumberField" id="phoneTypeSelect1"
                    (change)="updateContactInfo($event)" tabindex="1">
                    <option *ngFor="let phoneType of phoneTypes" [value]="phoneType.phoneTypeValue">
                        {{phoneType.typeName}}</option>
                </select>

                <input formControlName="phoneNumberControl" type="text" id="phoneNumberField1" name="phoneNumberField"
                    class="noMarginRight" (input)="updateContactInfo($event)" maxlength="14" [class.preNextErrorInput]="getControlInvalid('phoneNumberControl')"
                    (keydown)="enforceFormat($event)" (keyup)="formatToPhone($event)"
                    (focusout)="handleCheckErrors($event)" [class.inputError]="phoneNumber1Error" tabindex="1">
            </div>

            <ng-container *ngIf="phoneNumberType1Error">
                <span class="formErrorMsg">Please select a phone type. </span>
            </ng-container>

            <ng-container *ngIf="phoneNumber1Error">
                <span class="formErrorMsg">Please enter in your phone number.</span>
            </ng-container>
        </div>
    </div>

    <ng-container *ngIf="addSecondPhone">
        <div class="phoneInfo phoneTwo">
            <div class="phoneDetails addedPhoneDetails">
                <select formControlName="phoneTypeControl2" name="phoneNumberField2" id="phoneTypeSelect2"
                    (change)="updateContactInfo($event)" tabindex="1">
                    <option *ngFor="let phoneType of phoneTypes" [value]="phoneType.phoneTypeValue">
                        {{phoneType.typeName}}</option>
                </select>

                <input formControlName="phoneNumberControl2" type="text" id="phoneNumberField2" name="phoneNumberField2"
                    class="noMarginRight" (input)="updateContactInfo($event)" maxlength="14" [class.preNextErrorInput]="getControlInvalid('phoneNumberControl2')"
                    (keydown)="enforceFormat($event)" (keyup)="formatToPhone($event)"
                    (focusout)="handleCheckErrors($event)" [class.inputError]="phoneNumber2Error" tabindex="1">

                <div class="removePhoneIcon" (click)="removePhoneBtn(2)" (keypress)="handleKeypress($event)" (mousedown)="handleMouseDown($event)" tabindex="1">
                    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 448 512">
                        <!--! Font Awesome Pro 6.1.1 by @fontawesome - https://fontawesome.com License - https://fontawesome.com/license (Commercial License) Copyright 2022 Fonticons, Inc. -->
                        <path d="M160 400C160 408.8 152.8 416 144 416C135.2 416 128 408.8 128 400V192C128 183.2 135.2 176 144 176C152.8 176 160 183.2 160 192V400zM240 400C240 408.8 232.8 416 224 416C215.2 416 208 408.8 208 400V192C208 183.2 215.2 176 224 176C232.8 176 240 183.2 240 192V400zM320 400C320 408.8 312.8 416 304 416C295.2 416 288 408.8 288 400V192C288 183.2 295.2 176 304 176C312.8 176 320 183.2 320 192V400zM317.5 24.94L354.2 80H424C437.3 80 448 90.75 448 104C448 117.3 437.3 128 424 128H416V432C416 476.2 380.2 512 336 512H112C67.82 512 32 476.2 32 432V128H24C10.75 128 0 117.3 0 104C0 90.75 10.75 80 24 80H93.82L130.5 24.94C140.9 9.357 158.4 0 177.1 0H270.9C289.6 0 307.1 9.358 317.5 24.94H317.5zM151.5 80H296.5L277.5 51.56C276 49.34 273.5 48 270.9 48H177.1C174.5 48 171.1 49.34 170.5 51.56L151.5 80zM80 432C80 449.7 94.33 464 112 464H336C353.7 464 368 449.7 368 432V128H80V432z"/>
                    </svg>
                </div>
            </div>

            <ng-container *ngIf="phoneNumberType2Error">
                <span class="formErrorMsg">Please select a phone type. </span>
            </ng-container>

            <ng-container *ngIf="phoneNumber2Error">
                <span class="formErrorMsg">Please enter in your phone number.</span>
            </ng-container>

            <!-- <ng-container *ngIf="addSecondPhone">
                <span class="removePhone" (click)="removePhoneBtn(2)" (keypress)="handleKeypress($event)"
                    (mousedown)="handleMouseDown($event)" tabindex="1">- Remove added number</span>
            </ng-container> -->
        </div>
    </ng-container>

    <ng-container *ngIf="addThirdPhone">
        <div class="phoneInfo phoneThree">
            <div class="phoneDetails addedPhoneDetails">
                <select formControlName="phoneTypeControl3" name="phoneNumberField3" id="phoneTypeSelect2"
                    (change)="updateContactInfo($event)" tabindex="1">
                    <option *ngFor="let phoneType of phoneTypes" [value]="phoneType.phoneTypeValue">
                        {{phoneType.typeName}}</option>
                </select>

                <input formControlName="phoneNumberControl3" type="text" id="phoneNumberField2" name="phoneNumberField3"
                    class="noMarginRight" (input)="updateContactInfo($event)" maxlength="14"
                    (keydown)="enforceFormat($event)" (keyup)="formatToPhone($event)" [class.preNextErrorInput]="getControlInvalid('phoneNumberControl3')"
                    (focusout)="handleCheckErrors($event)" [class.inputError]="phoneNumber3Error" tabindex="1">

                <div class="removePhoneIcon" (click)="removePhoneBtn(3)" (keypress)="handleKeypress($event)" (mousedown)="handleMouseDown($event)" tabindex="1">
                    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 448 512">
                        <!--! Font Awesome Pro 6.1.1 by @fontawesome - https://fontawesome.com License - https://fontawesome.com/license (Commercial License) Copyright 2022 Fonticons, Inc. -->
                        <path d="M160 400C160 408.8 152.8 416 144 416C135.2 416 128 408.8 128 400V192C128 183.2 135.2 176 144 176C152.8 176 160 183.2 160 192V400zM240 400C240 408.8 232.8 416 224 416C215.2 416 208 408.8 208 400V192C208 183.2 215.2 176 224 176C232.8 176 240 183.2 240 192V400zM320 400C320 408.8 312.8 416 304 416C295.2 416 288 408.8 288 400V192C288 183.2 295.2 176 304 176C312.8 176 320 183.2 320 192V400zM317.5 24.94L354.2 80H424C437.3 80 448 90.75 448 104C448 117.3 437.3 128 424 128H416V432C416 476.2 380.2 512 336 512H112C67.82 512 32 476.2 32 432V128H24C10.75 128 0 117.3 0 104C0 90.75 10.75 80 24 80H93.82L130.5 24.94C140.9 9.357 158.4 0 177.1 0H270.9C289.6 0 307.1 9.358 317.5 24.94H317.5zM151.5 80H296.5L277.5 51.56C276 49.34 273.5 48 270.9 48H177.1C174.5 48 171.1 49.34 170.5 51.56L151.5 80zM80 432C80 449.7 94.33 464 112 464H336C353.7 464 368 449.7 368 432V128H80V432z"/>
                    </svg>
                </div>
            </div>

            <ng-container *ngIf="phoneNumberType3Error">
                <span class="formErrorMsg">Please select a phone type. </span>
            </ng-container>

            <ng-container *ngIf="phoneNumber3Error">
                <span class="formErrorMsg">Please enter in your phone number.</span>
            </ng-container>

            <!-- <ng-container *ngIf="addThirdPhone">
                <span class="removePhone" (click)="removePhoneBtn(3)" (keypress)="handleKeypress($event)"
                    (mousedown)="handleMouseDown($event)" tabindex="1">- Remove added number</span>
            </ng-container> -->
        </div>
    </ng-container>

    <div class="addRemoveNumbersCtl">
        <ng-container *ngIf="!addThirdPhone">
            <span class="addPhone" (click)="addPhoneBtn()" (keypress)="handleKeypress($event)"
                (mousedown)="handleMouseDown($event)" tabindex="1">+ Add another number</span>
        </ng-container>
    </div>

    <div class="emailInfo">
        <label for="emailField" [class.required-field]="nameEmailReqOnly || nameAddressEmailReqOnly">
            Email
            <!-- <span class="optionalTag">(optional)</span> -->
        </label>
        <input formControlName="emailControl" type="email" id="emailField" name="emailField"
            [class.inputError]="emailError" (input)="updateContactInfo($event)" class="noMarginRight" email
            (focusout)="handleCheckErrors($event)" tabindex="1" [class.preNextErrorInput]="getControlInvalid('emailControl')">

        <ng-container *ngIf="emailError">
            <ng-container *ngIf="notificationSwitchToggleState">
                <span class="formErrorMsg">Please enter your email address to receive updates.</span>
            </ng-container>

            <ng-container *ngIf="!notificationSwitchToggleState">
                <span class="formErrorMsg">Please enter your email address.</span>
            </ng-container>

        </ng-container>
    </div>

    <div class="notificationCheck">
        <!-- <input type="checkbox" formControlName="notificationBox" id="notificationCheckBox" (change)="updateContactInfo($event)"> -->
        <label for="notificationBox">
            <div class="notificationLabel">
                <span id="notificationLabelText">Notifications</span>
                <span id="bellIcon">
                    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 448 512">
                        <!--! Font Awesome Pro 6.1.1 by @fontawesome - https://fontawesome.com License - https://fontawesome.com/license (Commercial License) Copyright 2022 Fonticons, Inc. -->
                        <path
                            d="M207.1 16C207.1 7.164 215.2 0 223.1 0C232.8 0 240 7.164 240 16V32.79C320.9 40.82 384 109 384 192V221.1C384 264.8 401.4 306.7 432.3 337.7L435 340.4C443.3 348.7 448 359.1 448 371.7C448 396.2 428.2 416 403.7 416H44.28C19.83 416 0 396.2 0 371.7C0 359.1 4.666 348.7 12.97 340.4L15.72 337.7C46.63 306.7 64 264.8 64 221.1V192C64 109 127.1 40.82 208 32.79L207.1 16zM223.1 64C153.3 64 95.1 121.3 95.1 192V221.1C95.1 273.3 75.26 323.4 38.35 360.3L35.6 363C33.29 365.3 31.1 368.5 31.1 371.7C31.1 378.5 37.5 384 44.28 384H403.7C410.5 384 416 378.5 416 371.7C416 368.5 414.7 365.3 412.4 363L409.7 360.3C372.7 323.4 352 273.3 352 221.1V192C352 121.3 294.7 64 223.1 64H223.1zM223.1 480C237.9 480 249.8 471.1 254.2 458.7C257.1 450.3 266.3 445.1 274.6 448.9C282.9 451.9 287.3 461 284.4 469.3C275.6 494.2 251.9 512 223.1 512C196.1 512 172.4 494.2 163.6 469.3C160.7 461 165.1 451.9 173.4 448.9C181.7 445.1 190.9 450.3 193.8 458.7C198.2 471.1 210.1 480 223.1 480z" />
                    </svg>
                </span>
            </div>
        </label>
        <div class="notificationControl">
            <input type="checkbox" formControlName="notificationBox" name="notificationBox" id="notificationCheckBox"
                (change)="updateContactInfo($event)" tabindex="1">
            <!-- <div id="labelContainer">
                <label class="switch" tabindex="0" (keypress)="handleKeypress($event, 'notificationCheckBox')" (mousedown)="handleMouseDown($event)">
                    <input
                        type="checkbox" formControlName="notificationBox" name="notificationBox"
                        id="notificationCheckBox" (change)="updateContactInfo($event)" tabindex="-1">
                    <span class="slider round"></span>
                </label>
                <div id="switchState" [class.toggledOnSwitch]="notificationSwitchToggleState"></div>
            </div> -->
            <label class="notificationText" for="notificationCheckBox">Yes, update me on the status of this problem by
                email</label>
        </div>
    </div>
</form>